export class OpenAuthenticationConnectorDetail {
  connectorName: string;
  description: string;
  status: string;
  authType: string;

  clientid: string;

  clientsecret: string;
  authorizationURL: string;
  accesstokenreq: string;







}
